import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import {
  Box,
  Paper,
  Typography,
  Button,
  Container,
  Alert
} from '@mui/material';
import BlockIcon from '@mui/icons-material/Block';
import LogoutIcon from '@mui/icons-material/Logout';

const AccessDenied: React.FC = () => {
  const { user, logout } = useAuth0();

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Paper sx={{ p: 4, width: '100%' }}>
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <BlockIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
            <Typography variant="h5" component="h1" gutterBottom>
              Access Denied
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
              You don't have permission to access this system.
            </Typography>
          </Box>

          <Alert severity="error" sx={{ mb: 3 }}>
            <Typography variant="body2">
              <strong>Logged in as:</strong> {user?.email}
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              Your Auth0 account doesn't have the required system access role to use the Advisor Dashboard.
            </Typography>
          </Alert>

          <Box sx={{ mb: 3 }}>
            <Typography variant="body2" color="text.secondary">
              <strong>What's happening?</strong>
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              The Advisor Dashboard requires the <strong>dashboard-access</strong> role in Auth0. Your account doesn't have this role assigned.
            </Typography>
          </Box>

          <Alert severity="info" sx={{ mb: 3 }}>
            <Typography variant="caption">
              <strong>To request access:</strong> Contact your system administrator and ask them to assign the <strong>dashboard-access</strong> role to your account in the Auth0 Dashboard.
            </Typography>
          </Alert>

          <Box sx={{ textAlign: 'center' }}>
            <Button
              fullWidth
              variant="contained"
              onClick={handleLogout}
              startIcon={<LogoutIcon />}
            >
              Sign Out
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default AccessDenied;
